
define('text!templates/bin_title.html',[],function () { return '<div class="header-c title" data-bind="{{bin_kind}}-count">{{bin_kind}} {{bin_label}}: <span class="count">{{count}}</span></div>';});

